/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import SelectSearch from 'react-select-search';
import { get, isEqual, throttle } from 'lodash-es';
// import './MultiSele.scss';
import { Field, ErrorMessage } from 'formik';
import MultiSelect from 'react-multi-select-component';

class Render extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            options: [],
            selectedOptions: [],
        };

        this.throttledGetOptions = throttle(this.getOptions, 1000);

    }
    
    componentDidMount() {
        this.getDefaultOptions();
    }

    componentDidUpdate(prevProps) {
        const {
            value,
            form,
            field,
            whereConditions,
        } = this.props;

        if (prevProps.value !== value) {
            this.getDefaultOptions();
        }
        // e.g. state change then city where condition changed.. so it should reset
        else if (!isEqual(prevProps.whereConditions, whereConditions)) {
            form.setFieldValue(field.name, []);
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                options: [],
             selectedOptions: [],

            });
        }
    }

    getOptionsByWhereClause = async ({ where }) => {
        const {
            displayKeyPath,
            valueKeyPath,
            apiCallAddonData,
            api,
        } = this.props;

        try {
            // fetch only data that is needed
            const select = displayKeyPath.reduce((total, current) => {
                // eslint-disable-next-line no-param-reassign
                total[current] = 1;
                return total;
            }, {});

            // get options from server
            const {
                data: {
                    data: {
                        data,
                    },
                },
            } = await api({
                where,
                select,
                ...apiCallAddonData,
            });

            // default option
            const optionsData = data.map((item) => {
                const displayName = displayKeyPath.map((path) => get(item, path)).filter((x) => !!x).join(', ');
                return {
                    name: displayName,
                    value: get(item, valueKeyPath),
                };
            });

            // update option in state
            this.setState({
                options: optionsData,
            });
        } catch (error) {
            console.error('LOG: getOptions -> error', error);
        }
    };

    getDefaultOptions = async () => {
        const {
            defaultValueFetchByKeyPath,
            value,
        } = this.props;
    
        if (!value || !defaultValueFetchByKeyPath) {
            return;
        }
    
        try {
            await this.getOptionsByWhereClause({
                where: {
                    [defaultValueFetchByKeyPath]: { $in: value },
                },
            });
        } catch (error) {
            console.error('LOG: getOptions -> error', error);
        }
    };

    getOptions = async (query) => {
        const {
            whereClauseKeysPaths,
            whereConditions,
        } = this.props;
        // console.log('Query:', query);

        // build where clause
        const whereWithOrCondition = {
            $or: [],
            ...whereConditions,
        };

        whereClauseKeysPaths.forEach((keyPath) => {
            const condition = {};
            condition[keyPath] = {
                $regex: query, // Match any part of the option
                $options: 'i', // Case-insensitive search
            };
            whereWithOrCondition.$or.push(condition);
        });

        // console.log('Where Clause:', whereWithOrCondition);

        try {
            await this.getOptionsByWhereClause({
                where: whereWithOrCondition,
            });
        } catch (error) {
            console.error('LOG: getOptions -> error', error);
        }
    };

    // handleChange = (selectedValue) => {
    //     console.log('selectedValues', selectedValue)
    //     const { form, field } = this.props;
    //     const { selectedOptions } = this.state;
    //     const updatedSelectedOptions = [...selectedOptions, selectedValue];

    //     this.setState({ selectedOptions: updatedSelectedOptions });
    //     form.setFieldValue(field.name, selectedValue);
    //     console.log('form', form)
    //     console.log('form values->',form.values)    
    //     console.log('updatedSelectedOptions', updatedSelectedOptions)
    // }

    render() {
        const {
            value,
            placeholder,
            disabled,
            onChange,
            field,
            form,
        } = this.props;

       
        const { options, selectedOptions } = this.state;
        // const selectedValues = Array.isArray(value) ? value : [];

        return (
            <>
                 {value !== undefined && (
                <SelectSearch
                    disabled={disabled}
                    options={Array.isArray(options) ? options : []}
                    getOptions={this.throttledGetOptions}
                    // onChange={this.handleChange}
                    onChange={(selectedValues) => {
                        const updatedSelectedOptions = new Set(selectedOptions);
                        const updatedValue = new Set(value);
                      
                        selectedValues.forEach(value => {
                          if (updatedSelectedOptions.has(value)) {
                            updatedSelectedOptions.delete(value);
                          }
                          if (updatedValue.has(value)) {
                            updatedValue.delete(value);
                          } else {
                            updatedSelectedOptions.add(value);
                          }
                        });
                      
                        const updatedSelectedOptionsArray = Array.from(updatedSelectedOptions);
                        const updatedValueArray = Array.from(updatedValue);
                      
                        this.setState({ selectedOptions: updatedSelectedOptionsArray });
                      
                        const allOptionsSet = new Set([...updatedValueArray, ...updatedSelectedOptionsArray]);
                        const allOptions = Array.from(allOptionsSet);
                      
                        form.setFieldValue(field.name, allOptions);
                      }}                  

                    value={[]} 
                    placeholder={placeholder}   
                    search
                    autoComplete="disabled"
                    multiple
                />
            )}
                <ErrorMessage
                    component="div"
                    className="text-danger"
                    name={field.name}
                />
            </>
        );
    }
}

Render.propTypes = {
    api: PropTypes.func.isRequired,
    apiCallAddonData: PropTypes.any,
    defaultValueFetchByKeyPath: PropTypes.string,
    disabled: PropTypes.bool,
    displayKeyPath: PropTypes.array.isRequired,
    field: PropTypes.shape({
        name: PropTypes.string,
    }).isRequired,
    form: PropTypes.shape({
        setFieldValue: PropTypes.func,
    }).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    valueKeyPath: PropTypes.string.isRequired,
    whereClauseKeysPaths: PropTypes.array,
    whereConditions: PropTypes.any,
    onChange: PropTypes.func,
};

Render.defaultProps = {
    apiCallAddonData: {},
    defaultValueFetchByKeyPath: '',
    disabled: false,
    placeholder: '',
    whereClauseKeysPaths: [],
    whereConditions: {},
    onChange: () => { },
    value: []
};

const MultiSelectUserDropdown = (props) => {
  
    return(
    <Field
        {...props}
        component={Render}
    />
);
}
export default MultiSelectUserDropdown;